"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const axios_1 = __importDefault(require("../../../../app/shared/lib/axios"));
const currency_1 = require("../../../../app/shared/utils/currency");
const useBanorte_1 = require("../../../../hooks/useBanorte");
const useBanorteStore_1 = require("../../../../stores/useBanorteStore");
const useSimulationStore_1 = require("../../../../stores/useSimulationStore");
const type_payment_field_vue_1 = __importDefault(require("../molecules/type-payment-field.vue"));
const loading_modal_vue_1 = __importDefault(require("../../../organisms/loading-modal.vue"));
const leading_step_vue_1 = __importDefault(require("../atoms/leading-step.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'step-three-banorte',
    emits: ["change"],
    setup(__props, { emit }) {
        const store = (0, useSimulationStore_1.useSimulationStore)();
        const banorteStore = (0, useBanorteStore_1.useBanorteStore)();
        const { fetch, isLoading } = (0, useBanorte_1.useBanorte)();
        const handleActiveExtendedWarranty = (active) => {
            banorteStore.extendedWarranty.include = active;
        };
        const handleTypeWarrantyField = async (warrantyId) => {
            banorteStore.extendedWarranty.payment = warrantyId === 1 ? "Financiado" : "Contado";
            await store.setStep(4);
        };
        (0, vue_2.onBeforeMount)(async () => {
            const { data } = await axios_1.default.post("/graphql", {
                query: `{optionByName(name: "extended_warranty"){ name options }}`
            });
            let value = JSON.parse(data.data.optionByName.options);
            banorteStore.extendedWarranty.value = value?.value ?? 0;
        });
        (0, vue_2.watch)(() => banorteStore.extendedWarranty, () => {
            fetch({
                enganchePercentage: banorteStore.enganchePercentage,
                enganche: banorteStore.engancheAmount,
                plazo: store.plazo,
                powerTrain: store.powerTrain,
                subsidiary: store.distributor,
                tipoSeguro: 1,
                entidadFederativa: store.state.id,
                importeCatSegDanio: null,
                garantia_extendida: banorteStore?.extendedWarranty?.include ?? false,
                pago_garantia: banorteStore?.extendedWarranty?.payment ?? 'Financiado',
                listaImporteSeguroDano: null
            }).then((response) => {
                banorteStore.data = response;
                if (banorteStore.data != null && banorteStore.data.resultado != undefined) {
                    banorteStore.data.resultado.listaSeguroAuto = [];
                    banorteStore.insurer = null;
                    emit("change");
                }
            });
        }, { deep: true });
        return { __sfc: true, store, banorteStore, fetch, isLoading, handleActiveExtendedWarranty, handleTypeWarrantyField, emit, parseToMexicanPeso: currency_1.parseToMexicanPeso, TypePaymentField: type_payment_field_vue_1.default, LoadingModal: loading_modal_vue_1.default, LeadingStep: leading_step_vue_1.default };
    }
});
